<template>
  <div class="page-view-report">
    <div class="panel-info-section">
      <div class="panel-info-section-title flex items-center">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目会议</span>
        <a-button icon="plus" size="small" type="indigo" class="v-ml-auto" @click="$router.push(`./meeting/draft?pid=${projectId}`)" v-if="project.state == 1">新增会议</a-button>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="meetingId" :loading="recordsLoading" :pagination="false" :data-source="records" :scroll="{ x: '100%' }">
        <a-table-column title="#" data-index="index" :width="50" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="会议主题" :width="300" :ellipsis="true" data-index="meetingTitle" align="left">
          <template slot-scope="text, record">
            <router-link :to="{ path: '/project/meeting/view', query: { id: record.meetingId } }" class="text-indigo hover-line">{{ record.meetingTitle }}</router-link>
          </template>
        </a-table-column>
        <a-table-column title="会议时间" data-index="meetingTime" :width="250" align="left">
          <template slot-scope="text, record">
            {{ record.meetingStartTime }}~{{ record.meetingEndTime }}
          </template>
        </a-table-column>
        <a-table-column title="专家清单" :width="200" data-index="experts" align="left">
          <template slot-scope="text, record">
            <div class="lineh-13">{{ record.experts ? record.experts.map(d => d.realName).join('，') : '' }}</div>
          </template>
        </a-table-column>
        <a-table-column title="投票情况" :width="250" data-index="votes" align="left">
          <template slot-scope="text, record">
            <div class="lineh-13" v-if="record.votes.length">
              共<b class="text-indigo">{{ record.votes.length }}</b>个投票，已完成<b class="text-green">0</b>，未完成<b class="text-red">0</b>
            </div>
            <span v-else>无投票主题</span>
          </template>
        </a-table-column>
        <a-table-column title="状态" data-index="state" :width="65" align="left">
          <template slot-scope="text, record">
            <span v-if="record.meetingState == 0">未发布</span>
            <span class="text-red" v-else-if="record.meetingState == 1">已发布</span>
            <span v-else-if="record.meetingState == 2">已结束</span>
          </template>
        </a-table-column>
        <a-table-column title="短信通知" :width="180" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="center" v-if="project.state == 1">
          <template slot-scope="text, record">
            <a-space :size="10">
              <template v-if="record.meetingState == 0">
                <span class="font-xs hover-line text-indigo" title="编辑" @click="$router.push(`./meeting/draft?id=${record.meetingId}&pid=${projectId}`)">编辑</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDel(record.meetingId)">删除</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="管理" @click="$router.push(`./meeting/view?id=${record.meetingId}&pid=${projectId}`)" v-else-if="record.meetingState == 1">管理</span>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`./meeting/view?id=${record.meetingId}&pid=${projectId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listMeetings, delMeeting } from '@/api/project/meeting'
export default {
  name: 'ProjectMeetingList',
  data() {
    return {
      projectId: null,
      records: [],
      recordsLoading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      recordId: undefined,
    }
  },
  computed: {
    project: vm => vm.$store.state.app.project,
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadRecords()
      }
    },
    loadRecords(page = 1, pageSize = 10, sorter) {
      this.recordsLoading = true
      let params = {
        projectId: this.projectId,
        page,
        pageSize,
        sorter,
        states: [-1, 1, 2, 3],
      }
      listMeetings(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          this.records = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.recordsLoading = false
      })
    },
    onPageChange(page, pageSize) {
      this.loadRecords(page, pageSize)
    },
    handleDel(meetingId) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delMeeting(meetingId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.loadRecords()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {});
        },
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
